import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fbaTypeToHuman'
})
export class TypeToHumanPipe implements PipeTransform {

  constructor (private translateService: TranslateService) {}

  transform (value: any): any {
    if (value && typeof value === 'string') {
      return this.translateService.instant(`app-detailed-dropdown-suggested.${value.toUpperCase()}`) || value;
    } else {
      return value;
    }
  }

}
